module.exports = "6d301bdc8a28667dd0367bdcb5fc85ef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/kirigami-top-shadow.png
// module id = 34
// module chunks = 0